module.exports = __webpack_public_path__ + "img/no-docs.1967d47a.svg";